  <span
    [class]="'flex-shrink-0 font-medium inline-block px-2 py-1 rounded-full text-xs ' + colorClasses()"
  >
    {{ label() }}
  </span>
